var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgApproved = function SvgApproved(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.95192 0 0 8.95192 0 20C0 31.0481 8.95192 40 20 40C31.0481 40 40 31.0481 40 20C40 8.95192 31.0481 0 20 0ZM30.2404 14.4712L17.3846 27.3846H17.375C17.2115 27.5481 16.7692 27.9135 16.2596 27.9135C15.8942 27.9135 15.4808 27.7115 15.1346 27.3654L9.75 21.9808C9.59615 21.8269 9.59615 21.5865 9.75 21.4327L11.4615 19.7212C11.5385 19.6442 11.6346 19.6058 11.7308 19.6058C11.8269 19.6058 11.9231 19.6442 12 19.7212L16.2692 23.9904L28 12.1731C28.0769 12.0962 28.1731 12.0577 28.2692 12.0577C28.375 12.0577 28.4712 12.0962 28.5385 12.1731L30.2212 13.9135C30.3942 14.0769 30.3942 14.3173 30.2404 14.4712Z",
    fill: "#5ECC4D"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgApproved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/approved.92710c7705725ec3314b613f63f0248f.svg";